import { makeStyles } from "@material-ui/core/styles";

export const useStyles = makeStyles((theme) => ({
  root: {
    flexGrow: 1,
    overflowX: "hidden",
    [theme.breakpoints.down("sm")]: {
      width: "100%",
    },
    "& .MuiTab-wrapper": {
      flexDirection: "row",
    },
    "& .Mui-selected": {
      fontWeight: 500,
    },
  },
  tabIcon: {
    margin: "0 6px 0 0 !important",
    width: 20,
  },
  tabHeader: {
    position: "relative",
    zIndex: "unset",
    background: "#fff",
    color: "#000",
    fontSize: 14,
    fontWeight: "500",
    boxShadow: "none",
    maxWidth: 600,
    [theme.breakpoints.down("xs")]: {
      maxWidth: 220,
    },

    "& .MuiTabScrollButton-root": {
      width: 20,
      height: 20,
      background: "#dcdada",
      borderRadius: 3,
      margin: 7,
      "& svg": {
        color: "#777777",
      },
      "&.MuiTabScrollButton-root.Mui-disabled": {
        opacity: 0.3,
        cursor: "not-allowed",
        pointerEvents: "unset",
      },
    },
    "& button": {
      opacity: "0.6",
      minWidth: "auto",
      padding: 0,
      fontWeight: 500,
      marginRight: 30,
      "&:last-child": {
        marginRight: 8,
      },
      [theme.breakpoints.down("xs")]: {
        marginRight: 15,
      },
      "&.Mui-selected $tabsBadge": {
        background: theme.palette.secondary.main,
        color: "#fff",
        "& img": {
          filter: "brightness(0) invert(1) !important",
        },
      },
      "&.Mui-selected $deleteTabBtn": {
        display: "block",
      },
    },
  },
  tabsBadge: {
    background: "#E1E1E1",
    color: "#777777",
    fontWeight: 500,
    height: 24,
    width: 24,
    display: "inline-flex",
    marginLeft: 10,
    justifyContent: "center",
    alignItems: "center",
    borderRadius: "50%",
    fontSize: 11,
  },
  tabsIcon: {
    filter: "none !important",
    width: 15,
  },
  deleteTabBtn: {
    display: "none",
    height: 20,
    width: 20,
    lineHeight: "29px",
    marginLeft: 6,
    borderRadius: "50%",
    "&:hover": {
      background: "#ccc",
    },
    "& svg": {
      fontSize: 16,
    },
  },
  tabName: {
    maxWidth: 170,
    display: "inline",
    lineHeight: 1.3,
  },
  dotIndicator: {
    height: 7,
    width: 7,
    minWidth: 7,
    borderRadius: "50%",
    background: "#EF7713",
    position: "absolute",
    top: -1,
    right: -10,
  },
}));
